import * as React from 'react';
import { observer } from 'mobx-react';
import SortableColumn from '../../../SortableColumn';
import GroupsStore from '../../../../GroupsStore';
import { sortDirection, valueFor } from '../../../../ListFilter';
import OrganizationColumnHead from '../../Columns/Organization/OrganizationColumnHead';
import MulticheckControls from '../../../../Multicheck/MulticheckControls';
import { MulticheckStore } from '../../../../Multicheck/Store';
import { GroupResource } from '../../../../GroupsStore/Types';

interface Props {
  store: GroupsStore;
  multicheckStore: MulticheckStore<GroupResource>;
}

const sortBy = (store: GroupsStore) => valueFor('sort_by', store.searchParameters);

const Head: React.FC<Props> = ({ store, multicheckStore }) => (
  <thead className="bg-gray-50">
    <tr>
      <th className="w-24 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
        <MulticheckControls store={multicheckStore} />
      </th>
      <SortableColumn
        columnName={'Group Name'}
        currentSortKey={sortBy(store)}
        sortDirection={sortDirection(store.searchParameters)}
        onSortClicked={() => store.sorting('group_name')}
        sortKey="group_name"
        className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
      />
      <OrganizationColumnHead store={store} />
      <SortableColumn
        columnName={'Participants'}
        currentSortKey={sortBy(store)}
        sortDirection={sortDirection(store.searchParameters)}
        onSortClicked={() => store.sorting('participants')}
        sortKey="participants"
        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
      />
      <SortableColumn
        columnName={'Last Login'}
        currentSortKey={sortBy(store)}
        sortDirection={sortDirection(store.searchParameters)}
        onSortClicked={() => store.sorting('last_sign_in_at')}
        sortKey="last_sign_in_at"
        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
      />
      <SortableColumn
        columnName={'Total Enrollments'}
        currentSortKey={sortBy(store)}
        sortDirection={sortDirection(store.searchParameters)}
        onSortClicked={() => store.sorting('total_enrollments_count')}
        sortKey="total_enrollments_count"
        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
      />
      <SortableColumn
        columnName={'Status'}
        currentSortKey={sortBy(store)}
        sortDirection={sortDirection(store.searchParameters)}
        onSortClicked={() => store.sorting('status')}
        sortKey="status"
        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        colSpan={2}
      />
    </tr>
  </thead>
);

export default observer(Head);
